<template>
  <div class="PeriodDatePicker">
    <div justify="center" align="center">
      <v-row justify="center" align="center" class="">
        <v-col justify="center" align="center" class="">
          <box :title="$t('search')" class="card">
            <v-row class="pa-2">
              <v-col class="my-auto py-0" cols="6" xs6 sm="4" md="4">
                <v-select
                  hide-details=""
                  v-model="year"
                  :items="years"
                  :label="$t('year')"
                  item-text="Name"
                  item-value="Name"
                  return-object
                  dense
                  outlined
                  v-on:change="changeYear"
                  class="my-auto py-0 pl-1"
                ></v-select>
              </v-col>

              <v-col class="my-auto py-0" cols="6" xs6 sm="4" md="4">
                <v-select
                  hide-details=""
                  v-model="month"
                  :items="months"
                  :label="$t('period')"
                  dense
                  outlined
                  class="my-auto py-0 pl-0 pl-sm-1"
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                sm="4"
                md="4"
                justify="center"
                align="center"
                class="d-flex mt-2 mt-sm-0 px-1"
              >
                <v-btn
                class="mt-auto"
                  block
                  color="primary"
                  @click="getResult()"
                  >{{ $t("show") }}</v-btn
                >
              </v-col>
            </v-row>
          </box>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import EosToastType from '../../model/EosToastType';
export default {
  data() {
    return {
      year: {},
      month: "",
      years: [],
      months: [],
    };
  },
  mounted() {
    this.getYears();
  },
  methods: {
    getYears() {
      this.$store
        .dispatch("GetEosPeriodicYearsList")
        .then((result) => {
          if (result.type === "success") {
            var data = [];
            data = result.data;
            this.years = data;
            //this.year = data.slice(-1)[0];
            this.year = this.years[this.years.length-1]
            this.getPeriods();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
      return [];
    },
    changeYear() {
      //this.year = e.Name
      this.getPeriods();
    },
    getPeriods() {
      if (this.year == {}) {
        return;
      }

      const params = new URLSearchParams();
      params.append("year", this.year.Name);

      this.$store
        .dispatch("GetEosPeriodList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            //if (data.length > 0) {
            // this.months = data;
            // this.month = data.slice(-1)[0];
            //debugger;
            var moment = require("jalali-moment");
             var nowMonth = moment().locale("fa").format("MM");
             nowMonth=parseInt(nowMonth.replace("0",""));
             let hasCurrentMount=data.includes(nowMonth);
             if(hasCurrentMount){
              this.months = data;
              this.month=nowMonth;
             }else{
              this.months = data;
              this.month = data.slice(-1)[0];
             }
            //  this.month =parseInt(nowMonth.replace("0",""));


            

            this.getResult();
            //}
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
      return [];
    },
    getResult() {
      //debugger
      // var moment = require("jalali-moment");
      //  var nowMonth = moment().locale("fa").format("MM");
      //  this.month =parseInt(nowMonth.replace("0",""));
      this.$emit("getDate", this.year.Name, this.month);
    },
  },
};
</script>

<style>
</style>